export default __webpack_public_path__ + "static/media/02.8672a1e7.png";